import * as React from "react";
import { singleton } from "logic/singleton";
const WidgetConfigurationContext = React.createContext(void 0);
export default singleton("contexts.WidgetConfigurationContext", () => WidgetConfigurationContext);
